import { StatusTab } from '@/features/ai/StatusTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/status')({
  component: StatusTab,
});
